var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"},[_c('AllEmailsCard',{attrs:{"data":_vm.emails}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }